// @flow
type StartChat = 'bravissimo/LIVE_HELP_START_CHAT';
export const START_CHAT: StartChat = 'bravissimo/LIVE_HELP_START_CHAT';
